<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="i-gold-medal">
      <path
        id="Vector"
        :fill="`url(#paint0_linear_${color})`"
        clip-rule="evenodd"
        d="M13.474 5.86225C13.0218 5.62455 12.515 5.5 12 5.5C11.485 5.5 10.9782 5.62455 10.526 5.86225L5.60431 8.44941C5.1187 8.70492 4.71344 9.08185 4.43113 9.54059C4.14883 9.99933 3.9999 10.5229 4 11.0564V15.9436C3.9999 16.4771 4.14883 17.0007 4.43113 17.4594C4.71344 17.9181 5.1187 18.2951 5.60431 18.5506L10.526 21.1377C10.9782 21.3754 11.485 21.5 12 21.5C12.515 21.5 13.0218 21.3754 13.474 21.1377L18.3947 18.5506C18.8805 18.2952 19.2859 17.9183 19.5684 17.4596C19.8509 17.0008 20 16.4772 20 15.9436V11.0554C20 10.5218 19.8509 9.99817 19.5684 9.53942C19.2859 9.08068 18.8805 8.7038 18.3947 8.44842L13.474 5.86225ZM12 10.5308C11.7085 10.5308 11.5135 10.8673 11.1234 11.5433L11.0228 11.7175C10.912 11.9095 10.8566 12.0045 10.7703 12.0679C10.6831 12.1312 10.5753 12.155 10.3598 12.2015L10.1647 12.245C9.40724 12.4103 9.02848 12.4925 8.93816 12.7716C8.84783 13.0517 9.10649 13.3426 9.62279 13.9246L9.75622 14.075C9.903 14.2403 9.9769 14.3225 10.0098 14.4254C10.0426 14.5283 10.0313 14.6382 10.0098 14.8589L9.98922 15.0598C9.91121 15.8368 9.87221 16.2257 10.1073 16.3979C10.3433 16.5701 10.6985 16.4128 11.4077 16.098L11.5905 16.0169C11.7927 15.9278 11.8933 15.8833 12 15.8833C12.1067 15.8833 12.2073 15.9278 12.4095 16.0169L12.5922 16.098C13.3015 16.4138 13.6567 16.5701 13.8927 16.3979C14.1288 16.2257 14.0888 15.8368 14.0108 15.0598L13.9902 14.8589C13.9687 14.6382 13.9574 14.5283 13.9902 14.4254C14.0231 14.3235 14.097 14.2403 14.2438 14.075L14.3772 13.9246C14.8935 13.3426 15.1522 13.0517 15.0618 12.7716C14.9715 12.4925 14.5928 12.4103 13.8353 12.245L13.6402 12.2015C13.4247 12.155 13.3169 12.1322 13.2297 12.0679C13.1434 12.0045 13.088 11.9095 12.9772 11.7175L12.8766 11.5433C12.4865 10.8683 12.2915 10.5308 12 10.5308Z"
        fill-rule="evenodd"
      />
      <path
        id="Vector_2"
        d="M11 2.5H13C14.886 2.5 15.828 2.5 16.414 3.08337C17 3.66675 17 4.60453 17 6.48208V6.5L14.154 4.95495C13.4932 4.59632 12.7526 4.4084 12 4.4084C11.2474 4.4084 10.5068 4.59632 9.846 4.95495L7 6.5V6.48208C7 4.60453 7 3.66675 7.586 3.08337C8.172 2.5 9.114 2.5 11 2.5Z"
        fill="#FF5757"
      />
    </g>
    <defs>
      <linearGradient
        :id="`paint0_linear_${color}`"
        gradientUnits="userSpaceOnUse"
        x1="0.195993"
        x2="15.9699"
        y1="4.59243"
        y2="22.4849"
      >
        <stop
          :stop-color="color"
          offset="0.255898"
        />
        <stop
          :stop-color="computedColor"
          offset="0.618417"
        />
        <stop
          :stop-color="color"
          offset="0.965625"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script lang="ts" setup>
const props = defineProps<{ color: string }>();

function calculateMiddleColor(color: string): string {
  const hexToRgb = (hex: string) => {
    const bigint = Number.parseInt(hex.slice(1), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
    };
  };

  const rgbToHex = (r: number, g: number, b: number) => {
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  };

  const adjustColor = (value: number, factor: number) => {
    return Math.round(Math.min(255, value * factor));
  };

  const rgb = hexToRgb(color);

  // Модифицируем цвет, например, делаем его на 10% светлее
  const factor = 1.5;

  const middleColor = {
    r: adjustColor(rgb.r, factor),
    g: adjustColor(rgb.g, factor),
    b: adjustColor(rgb.b, factor),
  };

  return rgbToHex(middleColor.r, middleColor.g, middleColor.b);
}

const computedColor = computed(() => {
  return calculateMiddleColor(props.color);
});
</script>

<style scoped>

</style>
